<h1>You are not authorized to access this page.</h1>
<p>
  You do not have permission to view this page. If you have questions regarding your permissions in
  OnBoard, please contact
  {{ contactInfo }}.
</p>
<p>
  Go
  <a [routerLink]="[homeUrl]">Home</a>
</p>
